// extracted by mini-css-extract-plugin
module.exports = {"compTable":"CompTable_compTable__1Bx1A","red":"CompTable_red__39858","green":"CompTable_green__3unvv","sep":"CompTable_sep__1PiwA"};